import { combineReducers } from "redux";
import authUser from "./login/reducer";
import overlay from "./overlay/reducer";

const rootReducer = combineReducers({
authUser,overlay
});

export default rootReducer;